// ─── Query Keys ───────────────────────────────────────────────────────────────
// Centralised key factory — import from here to ensure consistent cache keys.

export const queryKeys = {
  // Bird Movements
  movements: {
    all: ['bird-movements'] as const,
    list: (filters?: Record<string, unknown>) =>
      ['bird-movements', 'list', filters ?? {}] as const,
    detail: (id: string) => ['bird-movements', 'detail', id] as const,
  },

  // Flock Population
  flockPopulation: {
    all: ['flock-population'] as const,
    list: (filters?: Record<string, unknown>) =>
      ['flock-population', 'list', filters ?? {}] as const,
    detail: (flockId: string) => ['flock-population', 'detail', flockId] as const,
  },

  // Sale Records
  saleRecords: {
    all: ['sale-records'] as const,
    list: (filters?: Record<string, unknown>) =>
      ['sale-records', 'list', filters ?? {}] as const,
    detail: (id: string) => ['sale-records', 'detail', id] as const,
  },
} as const;
